export default __webpack_public_path__ + "static/media/Lobster-Regular.9535d77e.ttf";